import { observable } from 'mobx';
import { FormikHelpers } from 'formik';

import {
  API_FUNCTION_TYPE,
  API_FUNCTION_TYPE_ID,
  API_ACCOUNT_DETAIL_EMPLOYERS,
  API_ACCOUNT_DETAIL_EMPLOYER,
  API_ACCOUNT_EMPLOYERS,
  API_ACCOUNT_EMPLOYER,
} from 'api/endpoints';

import { FormStore } from 'stores/formStore';
import { RootStore } from 'stores/rootStore';
import { Employer, EmployersData } from './model';
import { ViewMode } from 'pages/Accounts/Edit/components/viewModes';

export class EmployersStore extends FormStore<Employer> {
  accountId: string;
  endpointEmployer: API_FUNCTION_TYPE_ID;
  endpointEmployers: API_FUNCTION_TYPE;

  @observable employersData?: EmployersData;
  @observable lookupStatus?: number;

  constructor(rootStore: RootStore, accountId: string, viewMode?: ViewMode) {
    super(rootStore);
    this.accountId = accountId;
    this.employersData = undefined;

    this.endpointEmployer = viewMode === ViewMode.DETAIL ? API_ACCOUNT_DETAIL_EMPLOYER : API_ACCOUNT_EMPLOYER;
    this.endpointEmployers = viewMode === ViewMode.DETAIL ? API_ACCOUNT_DETAIL_EMPLOYERS : API_ACCOUNT_EMPLOYERS;
  }

  fetchEmployersData = async () => {
    this.rootStore.stores.uiStore.setLoading(true);
    const response = await this.rootStore.stores.apiStore.get<EmployersData>(this.endpointEmployers(this.accountId));
    if (response?.data) {
      this.employersData = response.data;
    }
    this.rootStore.stores.uiStore.setLoading(false);
  };

  fetchEmployer = async (employerId: string) => {
    this.rootStore.stores.uiStore.setLoading(true);
    await this.fetchData(this.endpointEmployer(this.accountId, employerId));
    this.rootStore.stores.uiStore.setLoading(false);
  };

  deleteEmployer = async (employerId: string) => {
    this.rootStore.stores.uiStore.setLoading(true);
    await this.rootStore.stores.apiStore.delete(this.endpointEmployer(this.accountId, employerId));
    this.rootStore.stores.uiStore.setLoading(false);
  };

  handleSubmit = async (values: Employer, formikHelpers: FormikHelpers<Employer>) => {
    return await this.submitData(this.endpointEmployers(this.accountId), values, {
      formikHelpers,
      reset: false,
      validationPrefixDepth: 0,
      singleValueResponse: true,
    });
  };

  resetLookupStatus = () => (this.lookupStatus = undefined);

  getEmployerFromARES = async (companyNumber: string, formikHelpers: FormikHelpers<Employer>): Promise<boolean> => {
    this.resetLookupStatus();
    const response = await this.rootStore.stores.apiStore.patch<Employer>(this.endpointEmployers(this.accountId), {
      companyNumber,
    });
    this.lookupStatus = response?.status;
    if (response?.data) {
      formikHelpers.setValues(response.data);
      return true;
    } else {
      return false;
    }
  };
}
